import React from "react";

import { ActiveBox } from "../active-box";
import { PlaceholderImage } from "../placeholder";

import "./designs-thumb.css";

export const DesignsThumb = ({
	thumbUrl,
	isActive,
	onClick,
	className,
	style,
	preventFocusScrollOnMouseDown,
}: {
	thumbUrl: string;
	isActive?: boolean;
	onClick?(): void;
	className?: string;
	style?: React.CSSProperties;
	/** When pressing this as button in a list, the focus auto-scroll is prevented to allow the smooth scrolling of parent code */
	preventFocusScrollOnMouseDown?: boolean;
}) => (
	<button
		className={`designs-thumb${className ? ` ${className}` : ""}`}
		style={style}
		role="option"
		aria-selected={isActive}
		onMouseDown={(e) => {
			if (preventFocusScrollOnMouseDown) {
				// Prevent browser focus auto-scroll so programmatic smooth scrolling can run reliably.
				e.preventDefault();
			}
		}}
		onClick={(e) => {
			e.stopPropagation();
			if (onClick) onClick();
		}}
	>
		<ActiveBox className="designs-thumb__img-container" isActive={isActive}>
			<PlaceholderImage className="designs-thumb__img" src={thumbUrl} loading="lazy" />
		</ActiveBox>
	</button>
);
